export function createImgElement(src: string, cssClass?: string): HTMLImageElement {
  const element: HTMLImageElement = document.createElement('img');
  element.src = src;
  if (cssClass) {
    element.className = cssClass;
  }
  return element;
}

export function createSpanElement(cssClass?: string, innerText?: string, innerHTML?: any): HTMLSpanElement {
  const element = document.createElement('span');

  if (cssClass) {
    element.className = cssClass;
  }

  if (innerText) {
    element.innerText = innerText;
  }

  if (innerHTML) {
    element.appendChild(innerHTML);
  }

  return element;
}
